<div class="display-flex flex-row flex-wrap flex-gap-10 mgb-10">
  <mat-checkbox id="activity-filter-activations" [(ngModel)]="showActivations">Show Activations</mat-checkbox>
  <mat-checkbox id="activity-filter-returns" [(ngModel)]="showReturns">Show Returns</mat-checkbox>
  <mat-checkbox id="activity-filter-tokens" [(ngModel)]="showTokens">Show Tokens</mat-checkbox>
  <mat-form-field appearance="fill" class="min-w-px-350">
    <mat-label>Search</mat-label>
    <input matInput id="searchbar" [(ngModel)]="queryString" placeholder="Search for user, contract, hostname/ip, comment or activation type" />
  </mat-form-field>
</div>
<div class="table-loading-state" *ngIf="loading">
  <mat-spinner diameter="56"></mat-spinner>
</div>
<div class="table-responsive fh-table" *ngIf="!loading">
  <table class="table table-striped table-hover activity-table">
    <colgroup>
      <col class="col-date">
      <col class="col-action">
      <col class="col-product">
      <col class="col-hostname">
      <col class="col-count">
      <col class="col-comment">
    </colgroup>
    <thead>
      <tr>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activity-date" (click)="sortBy('date')">Date <mat-icon>{{ getSortIcon('date') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activity-action" (click)="sortBy('action')">Action <mat-icon>{{ getSortIcon('action') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activity-product" (click)="sortBy('product')">Product <mat-icon>{{ getSortIcon('product') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activity-hostname" (click)="sortBy('hostname')">Hostname (IP) <mat-icon>{{ getSortIcon('hostname') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activity-count" (click)="sortBy('count')">Count <mat-icon>{{ getSortIcon('count') }}</mat-icon></button></th>
        <th><button mat-button type="button" class="table-sort-button" id="sort-activity-comment" (click)="sortBy('comment')">Comments <mat-icon>{{ getSortIcon('comment') }}</mat-icon></button></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="displayedActivities.length === 0">
        <td colspan="6" class="table-empty-state">No activity matches the current filters.</td>
      </tr>
      <tr *ngFor="let activity of displayedActivities">
        <td class="nowrap-cell">{{activity?.timestamp | date: "dd MMMM yyyy"}}</td>
        <td class="nowrap-cell">{{activity?.action | titlecase}}</td>
        <td class="nowrap-cell">{{activity?.product}}</td>
        <td><span class="ellipsis-cell hostname-cell" [matTooltip]="activity?.hostname || ''">{{activity?.hostname}}</span></td>
        <td class="nowrap-cell">{{activity?.count}}</td>
        <td><span class="ellipsis-cell" [matTooltip]="activity?.comment || ''">{{activity?.comment}}</span></td>
      </tr>
    </tbody>
  </table>
</div>
